"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAllowedException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when an action is attempted that is disallowed by the system for whatever reason not relating to
 * authorization.
 *
 * For example:
 * - Attempting to apply an expired discount code.
 * - Attempting to process a renewal order on an inactive subscription.
 *
 * These actions are forbidden by the requirements of the system, not because of anything permission related.
 *
 */
class NotAllowedException extends domain_exception_1.DomainException {
}
exports.NotAllowedException = NotAllowedException;
